// extracted by mini-css-extract-plugin
export default {"container":"TaskBuild_container__Aj0zi"};